import z from 'zod';
export const EMPLOYEE_VARIABLE_MAPPING = {
    'address.address': 'SALARIE_1_ADRESSE',
    'address.city': 'SALARIE_1_VILLE',
    'address.postalCode': 'SALARIE_1_CODE_POSTAL',
    birthdayDate: 'SALARIE_1_DATE_NAISSANCE',
    classification: 'SALARIE_1_CLASSIFICATION',
    firstName: 'SALARIE_1_PRENOM',
    lastName: 'SALARIE_1_NOM',
    position: 'SALARIE_1_POSTE',
    title: 'SALARIE_1_CIVILITE',
};
const employeeDocxVariableValues = Object.values(EMPLOYEE_VARIABLE_MAPPING);
if (employeeDocxVariableValues.some((value, index) => employeeDocxVariableValues.indexOf(value) !== index)) {
    throw new Error('EMPLOYEE_VARIABLE_MAPPING: duplicate DOCX variable values');
}
export const employeeDocxVariableValue = z.enum(employeeDocxVariableValues);
export const employeeDocxVariable = (value) => employeeDocxVariableValue.parse(value);
export const isEmployeeDocxVariable = (value) => employeeDocxVariableValue.safeParse(value).success;
//# sourceMappingURL=employee-variable-mapping.js.map